/* eslint-disable @typescript-eslint/no-explicit-any */
import axiosInstance from "../new-color-axiosInstance";
import { NewGiftActivityDto } from "./gift.interface";

interface Response<T> {
  success: boolean;
  code: string;
  msg: string;
  data: T;
  traceId: string;
  result: boolean;
}

// 查询礼包 https://cf.jd.com/pages/viewpage.action?pageId=629977547
// https://joyspace.jd.com/pages/lrBcvf2GPQC72T35eZsI  3.6
export const giftQuery = (requestData?: any): Promise<Response<NewGiftActivityDto>> => {
  return axiosInstance
    .get<Response<NewGiftActivityDto>>(`marketing_interact_getGiftPack`,{
      params: { ...requestData }, 
    }, false)
    .then((response) => response.data)
    .catch((error: any) => error);
};
